module.exports = __webpack_public_path__ + "static/project3iphone-3cec18aad21655a504ce2d705e32dc41.png";